import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import ReactPlayer from 'react-player';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../scss/components/GenericBanner/slider.scss"
import style from '../../../scss/components/GenericBanner/slider';
import SafeHTML from "../SafeHTML";
import YouTubeLogo from "../../../img/youtube.svg"

// Utility function to split text by /# and create lines
// Using class names instead of inline styles
// Fixed to preserve text before "ColorFlex® L2:"
const formatTextWithLineBreaks = (text, isMobile = false) => {
    if (!text) return null;
    
    // If this is button text and we're on mobile, check if it needs to be shortened
    if (isMobile && text.includes("Schedule a demo for your application")) {
        return "Schedule demo";
    }
    
    // Handle specific case without line breaks
    const specificText = 'Seamless Upgrade/# from ColorFlex EZ/# to ColorFlex® L2.';
    if (isMobile && text.includes(specificText)) {
        return text.replace(/\/#/g, ' ');
    }
    
    return text.split('/#').map((line, index) => {
      // Check if the line contains "ColorFlex® L2:" or "ColorFlex® L2 Tomato"
      if (line.includes("ColorFlex® L2:") || line.includes("ColorFlex® L2 Tomato")) {
        const separator = line.includes("ColorFlex® L2:") ? "ColorFlex® L2:" : "ColorFlex® L2 Tomato";
        const parts = line.split(separator);
        
        // Preserve text before ColorFlex
        const beforeText = parts[0];
        const afterText = parts[1];
        
        return (
          <React.Fragment key={index}>
            <span>
              {beforeText}
              <span className="colorflex-brand-highlight">
                {separator}
              </span>
              {afterText}
            </span>
            {index < text.split('/#').length - 1 && <br />}
          </React.Fragment>
        );
      }
      
      return (
        <React.Fragment key={index}>
          {line}
          {index < text.split('/#').length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

const SimpleSlider = (props) => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');
    const [isColorFlexL2Page, setIsColorFlexL2Page] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Check screen size on component mount and when window is resized
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768); // Common breakpoint for mobile
        };
        
        // Initial check
        checkScreenSize();
        
        // Add resize listener
        window.addEventListener('resize', checkScreenSize);
        
        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const openPopup = (url) => {
        if (url.toLowerCase().includes("youtube")) {
            setPopupOpen(true);
            setVideoUrl(url);
        } else {
            window.open(url);
        }
    };

    useEffect(() => {
        let isColorFlexL2 = window.location.pathname.includes("colorflex-l2")
        if (isColorFlexL2) {
            setIsColorFlexL2Page(isColorFlexL2)  
        }
    }, [])

    const closePopup = () => {
        setPopupOpen(false);
    };

    var settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnHover: true,
        pauseOnFocus: true,
    };
    let slider = props.sliderData

    return (
        !window.location.pathname.includes("products") ?
            <div>
                <Slider {...settings}>
                {
                    slider.map((sliderData, index) => {
                    const slideNumber = (index % 5) + 1;
                    const bannerContentClass = `bannerContent-${slideNumber}`;
                    const bannerTitleClass = `banner-title-${slideNumber}`;
                    const bannerDescClass = `banner-desc-${slideNumber}`;
                    const bannerButtonClass = `banner-buttontext-${slideNumber}`;

                    return (
                        <div className='image-container' key={index}>
                            <div className={`bannerContent ${bannerContentClass}`}>
                                <div className="selectable-text">
                                    <h2 className={`banner-head ${bannerTitleClass}`}>
                                        {formatTextWithLineBreaks(props.imgData[index])}
                                    </h2>
                                </div>
                                <div className="selectable-text">
                                    <h2 className={`banner-sub ${bannerDescClass}`}>
                                        {formatTextWithLineBreaks(props.imgDesc[index])}
                                    </h2>
                                </div>
                                <div className="button-container">
                                    <button 
                                        className={`banner-button ${bannerButtonClass}`}
                                        onClick={() => openPopup(sliderData.href)}
                                    >
                                        {formatTextWithLineBreaks(props.buttonText[index], isMobile)}
                                    </button>
                                </div>
                            </div>
                            <img
                                src={sliderData.url}
                                alt={sliderData.alt}
                                className='image-view'
                                height="700"
                                width="1920"
                            />
                        </div>
                    );
                    })
                }
                </Slider>
                {isPopupOpen && (
                    <div className="video-popup" onClick={closePopup}>
                        <div className="popup-content">
                            <div className="video-container">
                                <iframe
                                    title="Video Popup"
                                    width="560"
                                    height="315"
                                    src={videoUrl}
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                        <b className="close-btn"><span className="close-btn-span">×</span></b>
                    </div>
                )}
            </div>
            :
            <div>
                <Slider {...settings}>
                    {
                        slider.map((sliderData, index) => {
                            return (
                                <div className='product-image-container' key={index}>
                                    <div
                                        className={isColorFlexL2Page ? "product-bg-banner colorflex-l2-bg-banner" : "product-bg-banner"}
                                        style={{
                                            backgroundImage: `url(${sliderData.url})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                        }}
                                    >
                                        <img 
                                            className="product-img-small" 
                                            src={props.bannerData?.image?.url} 
                                        />

                                        <div className="banner-left-content-data">
                                            <div className="yt-banner-text selectable-text">
                                                <SafeHTML>{props.bannerData?.description}</SafeHTML>
                                            </div>
                                            <button 
                                                className="watch-now-yt"
                                                onClick={() => openPopup(sliderData.href)}
                                            >
                                                <img className="youtube-logo" src={YouTubeLogo} alt="youtube-logo" />
                                                <span className="watch-now-text selectable-text">{props.bannerData?.header}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </Slider>
                {isPopupOpen && (
                    <div className="video-popup" onClick={closePopup}>
                        <div className="popup-content">
                            <div className="video-container">
                                <iframe
                                    title="Video Popup"
                                    width="560"
                                    height="315"
                                    src={videoUrl}
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                        <b className="close-btn"><span className="close-btn-span">×</span></b>
                    </div>
                )}
            </div>
    );
}

export default SimpleSlider;
